import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useFormik } from "formik";
import airconService from "../services/aircon.service";
import { Airconvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import authsService from "../services/auths.service";
import Airconhistory from "./Airconhistory";
import Airconhistoryy from "./Airconhistoryy";
import Airconunity from "./Airconunity";
import analyticsService from "../services/analytics.service";
import Googlecharts from "../components/Googlecharts";
import airconhistoryService from "../services/airconhistory.service";
import clientService from "../services/client.service";
import categoryService from "../services/category.service";
import { format } from "date-fns";
import Qrcode from "../components/Qrcode";
import clientcategoryService from "../services/clientcategory.service";
import locationService from "../services/location.service";
import GenericPdfDownloader from "../components/GenericPdfDownloader";

const Airconevent = (props) => {
  const userinfo = authsService.userinfo();
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [url, setUrl] = useState("https://www.letscoolsupport.com/preventivemaintenance/#/airconview?aircon_id=")
  const ref = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");
  const [filterclientarr, setFilterclientarr] = useState([]);
  const [categoryaircontype, setCategoryaircontype] = useState([]);
  const [buildingarr, setBuildingarr] = useState([]);
  const [blockarr, setBlockarr] = useState([]);
  const [levelarr, setLevelarr] = useState([]);
  const [locationarr, setLocationarr] = useState([]);
  const [totalqr, setTotalqr] = useState([1])

  const [aircon_id, setAirconid] = useState();
  const [selected, setSelected] = useState("history");
  const [selectedarr, setSelectedarr] = useState([
    { label: "Maintenance history", value: "history" },
    { label: "Aircon units", value: "airconunit" },
    { label: "Expense Chart", value: "expensechart" },
  ]);
  //form initial value
  const formik = useFormik({
    initialValues: {
      aircon_id: "",
      aircon_name: "",
      client_id: "",
      aircon_building: "",
      aircon_block: "",
      aircon_level: "",
      aircon_location: "",
      aircon_type: "",
      total_unit: "",
      aircon_remark: "",
      aircon_status: "",
      user_name: userinfo.user_name,
    },
    validationSchema: Airconvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setAirconid(searchParams.get("aircon_id"));
    if (searchParams.get("aircon_id") != null) {
      setEventname("view");
      getAircon(searchParams.get("aircon_id"));
      getallAirconhistory();
    } else {
      setEventname("create");
    }
    getallClient();
    getallCategory();
    getallBuilding();
    getallClientBlock();
    getallClientLevel();
    getallClientlocation();
  }, []);
  //use effects
  useEffect(() => {

    if (searchParams.get("aircon_ids") != null) {
      formik.setFieldValue("aircon_id", searchParams.get("aircon_ids"))
    } else {

    }
  }, []);

  useLayoutEffect(() => {
    getallClientBlock();
    getallClientLevel();
    getallClientlocation();
  }, [formik.values.client_id])
  //current event
  const airconEvent = (eventname, value) => {
    if (value) {
      getAircon(value);
    }
    setEventname(eventname);
  };
  //get aircon
  const getAircon = (value) => {
    setIsLoaded(true);
    airconService
      .getAircon(value)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            aircon_id: data.aircon_id,
            aircon_name: data.aircon_name,
            client_id: data.client_id,
            aircon_building: data.aircon_building,
            aircon_block: data.aircon_block,
            aircon_level: data.aircon_level,
            aircon_location: data.aircon_location,
            aircon_type: data.aircon_type,
            total_unit: data.total_unit,
            aircon_remark: data.aircon_remark,
            aircon_status: data.aircon_status,
            user_name: userinfo.user_name,
          });

          var indents = [];
          for (var i = 0; i < data.total_unit; i++) {
            indents.push(i);
          }
          setTotalqr(indents)
          console.log(indents);
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create aircon
  const createAircon = () => {
    airconService
      .createAircon(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          navigate("/aircon");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //update aircon
  const updateAircon = () => {
    airconService
      .updateAircon(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          airconEvent("view");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete aircon
  const deleteAircon = (value) => {
    airconService
      .deleteAircon(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/aircon");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //statistics
  const data = [
    ["expenses", "Total cost"],
    [-50, 0],
    [5, 800],
    [50, 0],
  ];
  const [airconexpensearr, setAirconexpensearr] = useState("");
  //get allairconhistory
  const getallAirconhistory = async () => {
    setIsLoaded(true);
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      filterclient: "",
      filteraircon: searchParams.get("aircon_id"),
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await airconhistoryService
      .getallAirconhistory(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          const data = [
            ["type", "expense($)"],
            ["0", 0],
            ...res.data.result.data.map((d) => [
              d.ah_type + "(" + format(new Date(d.createdAt), "PPpp") + ")",
              Number(d.total_amount),
            ]),
          ];
          console.log(data);
          setAirconexpensearr(data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setFilterclientarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allcategory
  const getallCategory = async () => {
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      filtercategory: "aircon_type",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await categoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setCategoryaircontype(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get alllocation
  const getallBuilding = async () => {
    var data = {
      limit: 100,
      page: 1,
      filter: "",
      filterclient: "",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await locationService
      .getallLocation(data)
      .then((res) => {
        if (res.data.result) {
          setBuildingarr(res.data.result.data);
        } else {
          setBuildingarr([]);
        }
      })
      .catch((err) => {
        setBuildingarr([]);
      });
  };
  const getallClientBlock = async () => {
    var data = {
      limit: 100,
      page: 1,
      filter: "",
      filterclient: formik.values.client_id ? formik.values.client_id : "",
      filtercategory: "block",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setBlockarr(res.data.result.data);
        } else {
          setBlockarr([]);
        }
      })
      .catch((err) => {
        setBlockarr([]);
      });
  };
  const getallClientLevel = async () => {
    var data = {
      limit: 100,
      page: 1,
      filter: "",
      filterclient: formik.values.client_id ? formik.values.client_id : "",
      filtercategory: "level",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLevelarr(res.data.result.data);
        } else {
          setLevelarr([]);
        }
      })
      .catch((err) => {
        setLevelarr([]);
      });
  };
  const getallClientlocation = async () => {
    var data = {
      limit: 100,
      page: 1,
      filter: "",
      filterclient: formik.values.client_id ? formik.values.client_id : "",
      filtercategory: "location",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLocationarr(res.data.result.data);
        } else {
          setLocationarr([]);
        }
      })
      .catch((err) => {
        setLocationarr([]);
      });
  };

  const selectedfn = (value) => {
    setSelected(value);
  };
  // Call aircon clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="">
        {/*  container */}
        <div className="aircon-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex flex-wrap">
                <h5 className="card-title p-0 m-0 me-auto">Aircon</h5>
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdropqrcode"
                  className="btn "
                >
                  <i className="fa fa-qrcode"></i>
                </button>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="airconeventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="airconeventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              airconEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => airconEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-3">
                    <label htmlFor="aircon_id" className="form-label">
                      Aircon Id
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Aircon id (optional)"
                        id="aircon_id"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "edit"
                              ? true
                              : eventname == "delete"
                                ? true
                                : false
                        }
                        {...formik.getFieldProps("aircon_id")}
                      />
                    </div>
                    <div>
                      {formik.touched.aircon_id && formik.errors.aircon_id ? (
                        <div className="error">{formik.errors.aircon_id}</div>
                      ) : null}
                    </div>
                  </div>

                  {/* status */}
                  <div className="col-md-3">
                    <label htmlFor="client_id" className="form-label">
                      Client
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="client_id"
                        {...formik.getFieldProps("client_id")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="client_id"
                      >
                        <option value="" disabled>
                          Select client
                        </option>
                        {filterclientarr && filterclientarr.map((client, index) => (
                          <option key={index} value={client.client_id}>
                            {client.client_fullname}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.client_id && formik.errors.client_id ? (
                        <div className="error">{formik.errors.client_id}</div>
                      ) : null}
                    </div>
                  </div>
                  {/*  type */}
                  <div className="col-md-3">
                    <label htmlFor="aircon_type" className="form-label">
                      Aircon Type
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_type"
                        {...formik.getFieldProps("aircon_type")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_type"
                      >
                        <option value="" disabled>
                          Select type
                        </option>
                        {categoryaircontype && categoryaircontype.map((categoryaircontype, index) => (
                          <option
                            key={index}
                            value={categoryaircontype.category_name}
                          >
                            {categoryaircontype.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_type &&
                        formik.errors.aircon_type ? (
                        <div className="error">{formik.errors.aircon_type}</div>
                      ) : null}
                    </div>
                  </div>
                  {/* status */}
                  <div className="col-md-3">
                    <label htmlFor="aircon_status" className="form-label">
                      status
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_status"
                        {...formik.getFieldProps("aircon_status")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_status"
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_status &&
                        formik.errors.aircon_status ? (
                        <div className="error">
                          {formik.errors.aircon_status}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* building */}
                  <div className="col-md-4 d-none">
                    <label htmlFor="aircon_building" className="form-label">
                      Building
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_building"
                        {...formik.getFieldProps("aircon_building")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_building"
                      >
                        <option value="" disabled>
                          Select Building
                        </option>
                        {buildingarr && buildingarr.map((buildingarr, index) => (
                          <option key={index} value={buildingarr.location_name}>
                            {buildingarr.location_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_building &&
                        formik.errors.aircon_building ? (
                        <div className="error">
                          {formik.errors.aircon_building}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* block */}
                  <div className="col-md-4">
                    <label htmlFor="aircon_block" className="form-label">
                      Block
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_block"
                        {...formik.getFieldProps("aircon_block")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_block"
                      >
                        <option value="" disabled>
                          Select Block
                        </option>
                        {blockarr && blockarr.map((blockarr, index) => (
                          <option key={index} value={blockarr.category_name}>
                            {blockarr.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_block &&
                        formik.errors.aircon_block ? (
                        <div className="error">
                          {formik.errors.aircon_block}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* level */}
                  <div className="col-md-3">
                    <label htmlFor="aircon_block" className="form-label">
                      Level
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_level"
                        {...formik.getFieldProps("aircon_level")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_level"
                      >
                        <option value="" disabled>
                          Select Level
                        </option>
                        {levelarr && levelarr.map((levelarr, index) => (
                          <option key={index} value={levelarr.category_name}>
                            {levelarr.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_level &&
                        formik.errors.aircon_level ? (
                        <div className="error">
                          {formik.errors.aircon_level}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* location */}
                  <div className="col-md-3">
                    <label htmlFor="aircon_location" className="form-label">
                      Location or Unit
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="aircon_location"
                        {...formik.getFieldProps("aircon_location")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        aria-label="aircon_location"
                      >
                        <option value="" disabled>
                          Select Location or Unit
                        </option>
                        {locationarr && locationarr.map((locationarr, index) => (
                          <option key={index} value={locationarr.category_name}>
                            {locationarr.category_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {formik.touched.aircon_location &&
                        formik.errors.aircon_location ? (
                        <div className="error">
                          {formik.errors.aircon_location}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* location */}
                  <div className="col-md-10 d-none">
                    <label htmlFor="aircon_location" className="form-label">
                      location
                    </label>
                    <div className="input-group col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter location"
                        id="aircon_location"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        {...formik.getFieldProps("aircon_location")}
                      />
                    </div>
                    <div>
                      {formik.touched.aircon_location &&
                        formik.errors.aircon_location ? (
                        <div className="error">
                          {formik.errors.aircon_location}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* total unit */}
                  <div className="col-md-2">
                    <label htmlFor="total_unit" className="form-label">
                      Total unit
                    </label>
                    <div className="input-group col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter total unit"
                        id="total_unit"
                        type="number"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        {...formik.getFieldProps("total_unit")}
                      />
                    </div>
                    <div>
                      {formik.touched.total_unit && formik.errors.total_unit ? (
                        <div className="error">{formik.errors.total_unit}</div>
                      ) : null}
                    </div>
                  </div>

                  {/*  remarks */}
                  {/* location */}
                  <div className="col-md-12">
                    <label htmlFor="aircon_remark" className="form-label">
                      remark
                    </label>
                    <div className="input-group col-md-12">
                      <textarea
                        className="form-control"
                        placeholder="Enter remark"
                        id="aircon_remark"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                              ? true
                              : false
                        }
                        {...formik.getFieldProps("aircon_remark")}
                      />
                    </div>
                    <div>
                      {formik.touched.aircon_remark &&
                        formik.errors.aircon_remark ? (
                        <div className="error">
                          {formik.errors.aircon_remark}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
              <div className="pt-2 pb-2">
                {eventname === "create" ? (
                  <>
                    <button
                      disabled={!formik.isValid}
                      onClick={() => createAircon()}
                      className="btn btn-primary me-2"
                    >
                      Create
                    </button>
                    <button
                      onClick={formik.handleReset}
                      className="btn btn-secondary"
                    >
                      Clear
                    </button>
                  </>
                ) : eventname === "edit" ? (
                  <>
                    {" "}
                    <button
                      onClick={() => updateAircon()}
                      className="btn btn-primary me-2"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => airconEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : eventname === "delete" ? (
                  <>
                    <button
                      onClick={() => deleteAircon(formik.values.aircon_id)}
                      className="btn btn-danger me-2 "
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => airconEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    {/* <button onClick={() => navigate('/airconloyee')} className='btn btn-primary' >Back</button> */}
                  </>
                )}
              </div>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
        {/* servicing history add */}
        <div
          className={
            searchParams.get("aircon_id") == null ? "d-none" : "d-black"
          }
        >
          <div className="d-flex flex-wrap mb-3 mt-3 shadow-sm bg-white rounded p-1">
            {/* <a className="btn btn-secondary rounded-0">
            <i className="fa fa-cogs"></i>
          </a> */}
            {selectedarr.map((selectedarrs, index) => (
              <button
                onClick={() => selectedfn(selectedarrs.value)}
                key={index}
                className={
                  selected === selectedarrs.value
                    ? "btn  btn-primary  "
                    : "btn  "
                }
              >
                {selectedarrs.label}
              </button>
            ))}
          </div>
          {/* section tab page */}
          {eventname == "create" ? (
            <></>
          ) : (
            <div className="">
              {selected === "history" ? (
                <Airconhistoryy
                  aircon_id={formik.values.aircon_id}
                  client_id={formik.values.client_id}
                />
              ) : selected === "airconunit" ? (
                <Airconunity
                  aircon_id={formik.values.aircon_id}
                  client_id={formik.values.client_id}
                />
              ) : selected === "expensechart" ? (
                <Googlecharts
                  com_data={airconexpensearr}
                  chart_type="AreaChart"
                  haxis="type"
                  vaxis="aircon expenses"
                />
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
        {/*  qr code modal */}

        <div
          className="modal fade"
          id="staticBackdropqrcode"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropqrcodeLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div className="flex-fill fw-bold">QR Code</div>
                  <div>
                    <a className="btn" data-bs-dismiss="modal">
                      Close
                    </a>
                  </div>
                </div>
                <div id="qrcodeId">
                  {totalqr && totalqr.map((totalqr, i) => (
                    <div key={i}>
                      <Qrcode aircon_id={url+formik.values.aircon_id} /></div>
                  ))}

                </div>
                <div className="mt-3">
                  <GenericPdfDownloader
                    downloadFileName="CustomPdf"
                    rootElementId="qrcodeId"
                  />
                  {/*   <button className="btn btn-sm btn-outline-primary w-100">
                    Download
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Airconevent;
